import React from 'react'
import { useUpcomingEvents, useEventHighlights } from 'modules/events/hooks'
import ContentSlider from '../../components/ContentSlider/ContentSlider'
import { Sport } from 'modules/sport/types'

export const Content = ({ sport }: { sport: Sport }) => {
  const { eventsUpcoming } = useUpcomingEvents(sport.uuid)
  const { highlights } = useEventHighlights(sport.uuid)

  return (
    <>
      <ContentSlider
        title={`Upcoming ${sport.name} Events`}
        data={eventsUpcoming}
        event={true}
        sport={sport.name}
        type={'events'}
      />
      <ContentSlider
        title={`${sport.name} Highlights`}
        data={highlights}
        event={true}
        sport={sport.name}
        type={'highlight'}
      />
    </>
  )
}
